// extracted by mini-css-extract-plugin
export var box = "_5a-0";
export var check = "_5a-1";
export var checkboxButton = "_5a-6";
export var checkboxGroup = "_5a-5";
export var disabled = "_5a-7";
export var ghost = "_5a-9";
export var input = "_5a-2";
export var label = "_5a-4";
export var normal = "_5a-8";
export var uncheck = "_5a-3";